// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleCarousel_container__Wh5oJ","item":"SimpleCarousel_item__1kgul","hideMouseEvents":"SimpleCarousel_hideMouseEvents__pgRTJ"};